<template>
    <div :class="['input-group', 'm-0', customClass]">
      <button
        class="btn btn-sm btn-outline-secondary"
        type="button"
        @click="increment"
      >
        <i class="fa fa-plus"></i>
      </button>
  
      <input
        :id="uid"
        type="text"
        class="form-control text-center"
        v-model="counter"
        @change="updateSelection"
      />
  
      <button
        class="btn btn-sm btn-outline-secondary"
        type="button"
        @click="decrement"
      >
        <i class="fa fa-minus"></i>
      </button>
    </div>
  </template>
  
  <script setup>
  import { ref, watch, onMounted } from 'vue'
  
  // define all your props
  const props = defineProps({
    options:     { type: Array,   default: () => [] },
    min:         { type: Number,  default: 1 },
    max:         { type: Number,  default: 10 },
    modelValue:  { type:[Number,String],  default: 1 },
    label:       { type: String,  default: 'Select Options' },
    customClass: { type: String,  default: '' },
  })
  
  // emit declaration for v-model
  const emit = defineEmits(['update:modelValue','change'])
  
  // reactive state
  const counter = ref(props.modelValue)
  const uid     = ref('')
  
  // on mount, sync counter & generate a UID
  onMounted(() => {
    counter.value = parseFloat(props.modelValue)
    uid.value     = uniqueid()
  })
  
  // if parent changes v-model, update counter
  watch(
    () => props.modelValue,
    newVal => {
      counter.value = newVal
    }
  )
  
  function increment() {
    if (counter.value < props.max) {
      counter.value++
      updateSelection()
    }
  }
  
  function decrement() {
    if (counter.value > props.min) {
      counter.value--
      updateSelection()
    }
  }
  
  function updateSelection() {
    emit('update:modelValue', counter.value)
    emit('change', counter.value);
  }
  
  function uniqueid() {
    return 'id' + Math.random().toString(36).substring(2, 8)
  }
  </script>
  
  <style scoped>
  /* add any component-specific styles here */
   .btn-outline-secondary{
     border: 1px solid #ced4da;
   }

   .btn-sm, .btn-group-sm > .btn {
    --bs-btn-padding-y: 0.28rem;
    --bs-btn-padding-x: 0.6rem;
    --bs-btn-font-size: 0.7rem;
    --bs-btn-border-radius: 0.2rem;
    }
    input.form-control {
        padding:0.45rem 0.2rem;
    }
  </style>
  